module.exports = __webpack_public_path__ + "img/undead_1.40d0dbec.png";